import React, { Component } from "react";
import { connect } from "react-redux";
import { nextQuestion } from "./../../actions/assessment";
import config from "./../../config/config-secret.json";
import QuestionNumber from "./../QuestionNumber";

import axios from "axios";
import Webcam from "react-webcam";

let count = 0;

export class MultipleChoiceImageWithImageQuestion extends Component {
  constructor(props) {
    super(props);

    this.webcamRef = React.createRef();
  }

  componentDidMount() {
    count = 0;
    // SaveUserStateToServerHelper(this.props.assessment);
  }

  onUserMediaError = () => {
    alert("Can't access webcam, please contact administrator.");
  };

  onUserMedia = () => {};

  addCaptureImage = (imageb64, taken_at) => {
    axios
      .post(config.API_URL + `/administer_test/save_security_image/`, {
        imageb64,
        taken_at,
        tester_id: this.props.assessment.tester_id,
      })
      .catch((error) => {
        console.log(error);
      });
  };

  nextQuestion = async (id) => {
    if (count < 1) {
      count += 1;
      window.localStorage.setItem(
        this.props.assessment.key,
        JSON.stringify(this.props.assessment)
      );

      const { tester_id, ...last_session_info } = this.props.assessment;
      axios
        .post(config.API_URL + "/administer_test/update_tester_session_info/", {
          tester_id: tester_id,
          last_session_info: JSON.stringify(last_session_info),
        })
        .then((res) => {
          document.querySelector("#initloader").style.display = "none";
          this.props.nextQuestion(this.props.question_id, [id]);
        })
        .catch((error) => {
          document.querySelector("#initloader").style.display = "none";
          console.error(error);

          // Get readable message from server if available
          const serverMessage =
            error.response?.data?.message ||
            error.response?.data ||
            error.message ||
            "Unknown error";

          alert(
            `There appears to be a problem sending data to our server.
Please check your internet connection and try refreshing your browser.

Error details: ${serverMessage}

If the issue persists, please contact your administrator.`
          );
        });
    }
  };

  render() {
    return (
      <div className="question">
        {this.props.assessment.has_security_features && (
          <Webcam
            className="col-12 mb-4"
            style={{
              position: "absolute",
              right: "100%",
              display: "block",
            }}
            screenshotFormat="image/jpeg"
            muted={false}
            ref={this.webcamRef}
            onUserMediaError={this.onUserMediaError}
            onUserMedia={this.onUserMedia}
          />
        )}

        <div>
          <QuestionNumber />
          <p className="quesion-sub"></p>
        </div>

        {this.props.questionimage1 !== null && (
          <div className="row">
            <div className="col-md-6 col-lg-6 justify-content-center align-self-center">
              <h4>
                <span
                  dangerouslySetInnerHTML={{ __html: this.props.questiontext }}
                ></span>
              </h4>
            </div>
            <div className="col-md-6 col-lg-6 q-img">
              <img
                src={this.props.questionimage1}
                alt="test"
                className="img-fluid"
                // style={{ height: "200px", width: "230px" }}
              />
            </div>
          </div>
        )}

        {this.props.questionimage1 === null && (
          <div className="row">
            <div className="col-md-12 col-lg-12 justify-content-center align-self-center">
              <h4>
                <span
                  dangerouslySetInnerHTML={{ __html: this.props.questiontext }}
                ></span>
              </h4>
            </div>
          </div>
        )}

        <div
          className="choices-btn choice-comparison"
          data-toggle="buttons"
          style={{ "white-space": "nowrap" }}
        >
          {!!this.props.choices &&
            this.props.choices.map((value, index) => {
              return (
                <label
                  key={value.id}
                  className="btn btn-outline-warning thick-border"
                  onClick={() => {
                    this.nextQuestion(value.id);
                    if (this.props.assessment.has_security_features) {
                      this.addCaptureImage(
                        this.webcamRef.current.getScreenshot(),
                        new Date()
                      );
                    }
                  }}
                  data-choiceid={value.id}
                >
                  <div key={value.id} className="custom-control custom-radio">
                    <input
                      type="radio"
                      key={value.id}
                      id={"chkChoice" + value.id}
                      name="choices"
                      className="btn btn-default with-gap d-none checkbox-choices"
                    />
                    <img
                      src={config.API_DOMAIN + value.choice.image}
                      alt="choice"
                      className="img-thumbnail"
                      style={{ height: "170px", width: "170px" }}
                    />
                  </div>
                </label>
              );
            })}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  ...state,
});

const mapDispatchToProps = (dispatch) => ({
  nextQuestion: (question_id, choice_ids) =>
    dispatch(nextQuestion(question_id, choice_ids)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MultipleChoiceImageWithImageQuestion);
